import React from 'react';
import { Mail, Phone, Linkedin, MapPin } from 'lucide-react';
import { Badge } from './ui/badge';

const BAHero = () => {
  const metrics = [
    { number: '92→98%', label: 'Audit accuracy improvement', color: 'bg-blue-600' },
    { number: '100%', label: 'On-time sprints — 4 quarters', color: 'bg-teal-600' },
    { number: '40%', label: 'Pipeline latency reduced', color: 'bg-cyan-600' },
    { number: '2,000+', label: 'Enterprise users supported', color: 'bg-indigo-600' },
  ];

  return (
    <section className="relative min-h-screen flex items-center justify-center pt-20 pb-16 bg-slate-50">
      <div className="container mx-auto px-6">
        <div className="max-w-7xl mx-auto">
          <div className="grid md:grid-cols-2 gap-16 items-center">
            {/* Left Column - Text Content */}
            <div>
              <Badge className="mb-6 bg-blue-100 text-blue-800 border-blue-200 hover:bg-blue-200 font-semibold">
                IT Systems Business Analyst
              </Badge>
              
              <h1 className="text-5xl md:text-6xl font-bold text-slate-900 mb-6 leading-tight">
                Bridging people, process & platform
              </h1>
              
              <p className="text-lg text-slate-600 mb-8 leading-relaxed">
                5+ years turning complex IAM, compliance, and data challenges into clear requirements
                and shipped solutions. Currently at <strong className="text-slate-900">Marriott International</strong> in Bethesda, MD —
                connecting security engineering, product owners, and business stakeholders every sprint.
              </p>

              {/* Contact Info */}
              <div className="space-y-3 mb-6">
                <a href="mailto:udaynisha6@gmail.com" className="flex items-center gap-3 text-slate-600 hover:text-blue-600 transition-colors">
                  <div className="w-10 h-10 bg-blue-50 rounded-lg flex items-center justify-center">
                    <Mail size={18} className="text-blue-600" />
                  </div>
                  <span className="font-medium">udaynisha6@gmail.com</span>
                </a>
                <a href="tel:+14142176004" className="flex items-center gap-3 text-slate-600 hover:text-blue-600 transition-colors">
                  <div className="w-10 h-10 bg-blue-50 rounded-lg flex items-center justify-center">
                    <Phone size={18} className="text-blue-600" />
                  </div>
                  <span className="font-medium">+1 (414) 217-6004</span>
                </a>
                <a href="https://www.linkedin.com/in/nisha-bharadwaj-cspo-81378318b/" target="_blank" rel="noopener noreferrer" className="flex items-center gap-3 text-slate-600 hover:text-blue-600 transition-colors">
                  <div className="w-10 h-10 bg-blue-50 rounded-lg flex items-center justify-center">
                    <Linkedin size={18} className="text-blue-600" />
                  </div>
                  <span className="font-medium">LinkedIn</span>
                </a>
                <div className="flex items-center gap-3 text-slate-600">
                  <div className="w-10 h-10 bg-blue-50 rounded-lg flex items-center justify-center">
                    <MapPin size={18} className="text-blue-600" />
                  </div>
                  <span className="font-medium">Maryland, United States</span>
                </div>
              </div>

              <Badge variant="outline" className="bg-green-50 text-green-700 border-green-300 font-semibold">
                H1B transfer ready
              </Badge>
            </div>

            {/* Right Column - Metrics */}
            <div>
              <div className="grid grid-cols-2 gap-4">
                {metrics.map((metric, index) => (
                  <div
                    key={index}
                    className={`${metric.color} text-white rounded-lg p-6 shadow-lg hover:shadow-xl transition-all duration-300`}
                  >
                    <div className="text-3xl font-bold mb-2">{metric.number}</div>
                    <div className="text-sm leading-tight opacity-90">{metric.label}</div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default BAHero;